<template>
  <b-modal
    :id="refModal"
    :ref="refModal"
    title="Import Hàng Loạt Chương Trình Voucher"
    size="xl"
    hide-footer
  >
    <b-row>
      <b-col>
        <div class="form-group">
          <span>
            <b>Bước 1:</b> Tải file Excel mẫu
            <a href="javascript:void(0)" @click="downloadTemplate">tại đây</a>.
            File gồm 5 sheet: <b>Voucher</b>, <b>Mã voucher</b>, <b>Sản phẩm áp dụng</b>,
            <b>Cấu hình tích lũy</b>, <b>Khách hàng</b> — nối với nhau bằng cột <b>STT</b>.
            Cột <b>Cửa hàng</b> để trống = áp dụng tất cả cửa hàng.
          </span>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <span><b>Bước 2:</b> Chọn file đã điền và tải lên để kiểm tra</span>
        <UploadFileMulter
          v-on:send-file="onPreview"
          v-on:clear-file="onClear"
          :cmdUrl="'v2/vouchers/import-campaign-excel'"
        />
        <span v-if="fileName">Tên file: <b>{{ fileName }}</b></span>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col md="4">
        <b-form-group class="required-control mb-0">
          <label class="font-weight-bold">
            <b>Bước 3:</b> Doanh nghiệp áp dụng (cho mọi chương trình trong file)
          </label>
          <b-form-select
            size="sm"
            class="select-style"
            v-model="companyId"
            :options="companies"
            value-field="id"
            text-field="name"
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >-- Chọn doanh nghiệp --</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-container class="mt-4 pl-0 pr-0" v-show="preview.dataset.length">
      <h5 class="d-flex align-items-center flex-wrap">
        Kết quả kiểm tra ({{ preview.count }} chương trình)
        <b-badge class="ml-2" :variant="preview.isValid ? 'success' : 'danger'">
          {{ preview.isValid ? 'Hợp lệ' : 'Có lỗi' }}
        </b-badge>
        <small v-if="!preview.isValid" class="text-danger ml-2">
          — Vui lòng sửa file và tải lên lại
        </small>
      </h5>

      <b-alert
        v-if="preview.orphanErrors && preview.orphanErrors.length"
        show
        variant="warning"
        class="py-2"
      >
        <div
          v-for="(error, index) in preview.orphanErrors"
          :key="'orphan-' + index"
          class="d-flex align-items-start"
        >
          <i class="fa fa-exclamation-triangle mr-2 mt-1"></i>
          <span>{{ error }}</span>
        </div>
      </b-alert>

      <b-table
        responsive
        bordered
        hover
        small
        :fields="fields"
        :items="preview.dataset"
        class="campaign-table"
      >
        <template v-slot:cell(toggle)="row">
          <a
            href="javascript:void(0)"
            class="toggle-detail"
            :title="row.detailsShowing ? 'Thu gọn' : 'Xem chi tiết'"
            @click="row.toggleDetails"
          >
            <i :class="row.detailsShowing ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
          </a>
        </template>

        <template v-slot:cell(status)="row">
          <b-badge :variant="row.item.isValid ? 'success' : 'danger'">
            <i :class="row.item.isValid ? 'fa fa-check' : 'fa fa-times'" class="mr-1"></i>
            {{ row.item.isValid ? 'Hợp lệ' : row.item.errorCount + ' lỗi' }}
          </b-badge>
        </template>

        <template v-slot:cell(errors)="row">
          <span v-if="row.item.isValid" class="text-success">
            <i class="fa fa-check"></i>
          </span>
          <template v-else>
            <div
              v-for="(error, index) in row.item.errors"
              :key="index"
              class="detail-row-error"
            >
              {{ error }}
            </div>
          </template>
        </template>

        <template v-slot:row-details="row">
          <b-card no-body class="detail-card p-3">
            <b-row class="m-0">
              <b-col md="6" class="mb-3 mb-md-0 pl-0">
                <div class="detail-title">
                  Mã voucher
                  <b-badge variant="primary">{{ row.item.details.length }}</b-badge>
                </div>
                <b-table
                  v-if="row.item.details.length"
                  small
                  bordered
                  class="mb-0 detail-table"
                  :items="row.item.details"
                  :fields="codeFields"
                >
                  <template v-slot:cell(errors)="codeRow">
                    <i v-if="!codeRow.item.errors.length" class="fa fa-check text-success"></i>
                    <div
                      v-for="(error, i) in codeRow.item.errors"
                      :key="i"
                      class="detail-row-error"
                    >
                      {{ error }}
                    </div>
                  </template>
                </b-table>
                <div v-else class="detail-empty">Chưa có mã</div>
              </b-col>
              <b-col md="6" class="pr-0">
                <div class="detail-title">
                  Sản phẩm áp dụng
                  <b-badge variant="primary">{{ row.item.applyItems.length }}</b-badge>
                </div>
                <b-table
                  v-if="row.item.applyItems.length"
                  small
                  bordered
                  class="mb-0 detail-table"
                  :items="row.item.applyItems"
                  :fields="applyItemFields"
                >
                  <template v-slot:cell(errors)="applyRow">
                    <i v-if="!applyRow.item.errors.length" class="fa fa-check text-success"></i>
                    <div
                      v-for="(error, i) in applyRow.item.errors"
                      :key="i"
                      class="detail-row-error"
                    >
                      {{ error }}
                    </div>
                  </template>
                </b-table>
                <div v-else class="detail-empty">Áp dụng tất cả sản phẩm</div>
              </b-col>
            </b-row>
            <b-row class="m-0 mt-3">
              <b-col md="6" class="mb-3 mb-md-0 pl-0">
                <div class="detail-title">
                  Cấu hình tích lũy
                  <b-badge variant="primary">{{ row.item.cumulatives.length }}</b-badge>
                </div>
                <b-table
                  v-if="row.item.cumulatives.length"
                  small
                  bordered
                  class="mb-0 detail-table"
                  :items="row.item.cumulatives"
                  :fields="cumulativeFields"
                >
                  <template v-slot:cell(errors)="cumRow">
                    <i v-if="!cumRow.item.errors.length" class="fa fa-check text-success"></i>
                    <div
                      v-for="(error, i) in cumRow.item.errors"
                      :key="i"
                      class="detail-row-error"
                    >
                      {{ error }}
                    </div>
                  </template>
                </b-table>
                <div v-else class="detail-empty">Không có cấu hình tích lũy</div>
              </b-col>
              <b-col md="6" class="pr-0">
                <div class="detail-title">
                  Khách hàng áp dụng
                  <b-badge variant="primary">{{ row.item.customers.length }}</b-badge>
                </div>
                <b-table
                  v-if="row.item.customers.length"
                  small
                  bordered
                  class="mb-0 detail-table"
                  :items="row.item.customers"
                  :fields="customerFields"
                >
                  <template v-slot:cell(errors)="custRow">
                    <i v-if="!custRow.item.errors.length" class="fa fa-check text-success"></i>
                    <div
                      v-for="(error, i) in custRow.item.errors"
                      :key="i"
                      class="detail-row-error"
                    >
                      {{ error }}
                    </div>
                  </template>
                </b-table>
                <div v-else class="detail-empty">Áp dụng tất cả khách hàng</div>
              </b-col>
            </b-row>
          </b-card>
        </template>
      </b-table>
    </b-container>

    <div class="footer">
      <b-button
        :disabled="!preview.isValid || !preview.dataset.length || isSaving"
        variant="primary"
        size="sm"
        @click="confirmImport"
      >
        Xác nhận Import
      </b-button>
      <b-button class="ml-4" variant="secondary" size="sm" @click="$bvModal.hide(refModal)">
        Hủy
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import UploadFileMulter from '@/view/modules/upload/UploadFileMulter';
import ApiService from '@/core/services/api.service';
import { makeToastSuccess, makeToastFaile, getProgramCompanies } from '@/utils/common';
import { COMPANY_CODE } from '@/utils/enum';

const emptyPreview = () => ({ count: 0, isValid: false, dataset: [], orphanErrors: [] });

export default {
  components: { UploadFileMulter },
  data() {
    return {
      refModal: 'import-campaign-voucher',
      fileName: '',
      isSaving: false,
      preview: emptyPreview(),
      companies: [],
      companyId: null,
      fields: [
        { key: 'toggle', label: '', thStyle: { width: '36px' } },
        { key: 'stt', label: 'STT', thStyle: { fontWeight: 600, width: '6%' } },
        { key: 'name', label: 'Tên chương trình', thStyle: { fontWeight: 600, width: '26%' } },
        { key: 'codeCount', label: 'Số mã', thStyle: { fontWeight: 600, width: '8%' } },
        { key: 'applyItemCount', label: 'Số SP', thStyle: { fontWeight: 600, width: '8%' } },
        { key: 'status', label: 'Trạng thái', thStyle: { fontWeight: 600, width: '14%' } },
        { key: 'errors', label: 'Lỗi', thStyle: { fontWeight: 600, width: '38%' } },
      ],
      codeFields: [
        { key: 'code', label: 'Mã', thStyle: { width: '35%' } },
        { key: 'maxUse', label: 'Số lượt', thStyle: { width: '20%' } },
        { key: 'errors', label: 'Lỗi', thStyle: { width: '45%' } },
      ],
      applyItemFields: [
        { key: 'referenceType', label: 'Loại', thStyle: { width: '20%' } },
        { key: 'code', label: 'Mã', thStyle: { width: '20%' } },
        { key: 'name', label: 'Tên', thStyle: { width: '25%' } },
        { key: 'errors', label: 'Lỗi', thStyle: { width: '35%' } },
      ],
      cumulativeFields: [
        { key: 'quantityFrom', label: 'SL từ', thStyle: { width: '25%' } },
        { key: 'quantityTo', label: 'SL đến', thStyle: { width: '25%' } },
        { key: 'cumulativeValue', label: 'Giá trị giảm', thStyle: { width: '25%' } },
        { key: 'errors', label: 'Lỗi', thStyle: { width: '25%' } },
      ],
      customerFields: [
        { key: 'typeLabel', label: 'Loại', thStyle: { width: '35%' } },
        { key: 'value', label: 'Giá trị', thStyle: { width: '30%' } },
        { key: 'errors', label: 'Lỗi', thStyle: { width: '35%' } },
      ],
    };
  },
  created() {
    this.fetchCompany();
  },
  methods: {
    async fetchCompany() {
      try {
        ApiService.setHeader();
        const response = await ApiService.get('company');
        // Chỉ DDV và VDD được khai chương trình bán hàng
        this.companies = getProgramCompanies(
          (response.data.data || []).map((company) => ({
            id: company.id,
            name: company.name,
          })),
        );
        const defaultCompany = this.companies.find(
          (company) => company.id === COMPANY_CODE.DDV,
        );
        if (!this.companyId && defaultCompany) {
          this.companyId = defaultCompany.id;
        }
      } catch (error) {
        makeToastFaile('Không tải được danh sách doanh nghiệp!');
      }
    },
    async downloadTemplate() {
      try {
        const response = await ApiService.query('v2/vouchers/import-campaign-template', {
          responseType: 'blob',
        });
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Mau_Import_Voucher.xlsx';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        makeToastFaile('Không tải được file mẫu');
      }
    },
    onPreview(data, fileName) {
      this.fileName = fileName;
      if (!data || !data.dataset) {
        this.preview = emptyPreview();
        return;
      }
      // Tự mở chi tiết các chương trình lỗi để người dùng thấy ngay lỗi cần sửa.
      const dataset = data.dataset.map((item) => ({
        cumulatives: [],
        customers: [],
        ...item,
        _showDetails: !item.isValid,
      }));
      this.preview = { ...emptyPreview(), ...data, dataset };
    },
    onClear() {
      this.preview = emptyPreview();
      this.fileName = '';
    },
    async confirmImport() {
      if (this.isSaving) {
        return;
      }
      if (!this.companyId) {
        makeToastFaile('Vui lòng chọn doanh nghiệp áp dụng!');
        return;
      }
      this.isSaving = true;
      try {
        const response = await ApiService.post('v2/vouchers/confirm-import-campaign', {
          fileName: this.fileName,
          companyIds: String(this.companyId),
          campaigns: this.preview.dataset,
        });
        makeToastSuccess(response.data.message || 'Import thành công');
        // Kèm kết quả để màn danh sách nhắc việc phân nhóm (BE trả { count })
        this.$emit('imported', response.data.data || {});
        this.onClear();
        this.$bvModal.hide(this.refModal);
      } catch (error) {
        const message =
          error.response && error.response.data
            ? error.response.data.message
            : 'Import thất bại, vui lòng thử lại';
        makeToastFaile(message);
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  margin-top: 20px;
}
.campaign-table {
  max-height: 460px;
  overflow-y: auto;
}
.toggle-detail {
  color: #3699ff;
  font-size: 0.85rem;
}
.detail-card {
  background: #f8f9fa;
  border: none;
}
.detail-title {
  font-weight: 600;
  margin-bottom: 6px;
}
.detail-empty {
  font-style: italic;
  color: #8c8c8c;
  padding: 4px 0;
}
.detail-table {
  background: #fff;
}
.detail-row-error {
  color: #f64e60;
  font-size: 0.8rem;
  line-height: 1.3;
}
</style>
